import { AccountBalanceWallet } from "@mui/icons-material";
import {
  Box,
  Button,
  Skeleton,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { useState } from "react";

import { useBillingBalanceQuery } from "Billing/Api/Queries/useBillingBalanceQuery";
import { DepositModal } from "Billing/Components/DepositModal";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Price } from "Shared/Price/Price";

const BarWrapper = styled(Box)`
  background: ${(props) => props.theme.colors.backgroundTile};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${Radius.M};
  padding: ${(props) => props.theme.spacing(Spacing.S)} ${(props) => props.theme.spacing(Spacing.M)};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AvailableFundsBar = (): React.ReactNode => {
  const { t } = useResource();

  const { data, isLoading } = useBillingBalanceQuery();

  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={Spacing.M}>
        <BarWrapper sx={{ flex: 1 }}>
          <Typography variant="body1" fontWeight={600} color="text.secondary">
            {t(Resources.Billing.AvailableFunds)}:
          </Typography>
          {isLoading ? (
            <Skeleton variant="text" width={100} height={24} />
          ) : (
            <Typography variant="body1" fontWeight={700} color="text.primary">
              <Price amount={data?.balance ?? 0} />
            </Typography>
          )}
        </BarWrapper>
        <Button
          variant="contained"
          startIcon={<AccountBalanceWallet width={16} height={16} />}
          onClick={() => setIsDepositModalOpen(true)}
          sx={{
            px: Spacing.XL,
            py: 2.5,
          }}
        >
          {t(Resources.Billing.InitiateDeposit)}
        </Button>
      </Stack>
      <DepositModal
        isOpen={isDepositModalOpen}
        onClose={() => setIsDepositModalOpen(false)}
      />
    </>
  );
};
